import FontAwesomeIcon from "~/components/FontAwesome";

function DashboardWidgetHeader({
	icon,
	title,
	subtitle,
	badge,
	extra,
	gradient = 'linear-gradient(135deg, #6366f1 0%, #818cf8 60%, #a5b4fc 100%)',
}) {
	return (
		<div style={{
			background:     gradient,
			padding:        '14px 18px 12px',
			display:        'flex',
			alignItems:     'center',
			justifyContent: 'space-between',
			borderRadius:   '16px 16px 0 0',
		}}>
			<div style={{display: 'flex', alignItems: 'center', gap: 10}}>
				{icon && (
					<div style={{
						width:          38,
						height:         38,
						borderRadius:   10,
						background:     'rgba(255,255,255,0.2)',
						color: 		'#fff',
						display:        'flex',
						alignItems:     'center',
						justifyContent: 'center',
						flexShrink:     0,
					}}>
						<FontAwesomeIcon icon={icon} style={{color: '#fff', fontSize: 20}} />
					</div>
				)}
				<div>
					<div style={{color: '#fff', fontWeight: 700, fontSize: 14, lineHeight: 1.2}}>
						{title}
					</div>
					{subtitle && (
						<div style={{color: 'rgba(255,255,255,0.75)', fontSize: 11, marginTop: 2}}>
							{subtitle}
						</div>
					)}
				</div>
			</div>

			<div style={{display: 'flex', alignItems: 'center', gap: 8}}>
				{badge != null && (
					<div style={{
						background:   'rgba(255,255,255,0.22)',
						borderRadius: 20,
						padding:      '2px 10px',
						color:        '#fff',
						fontSize:     12,
						fontWeight:   600,
					}}>
						{badge}
					</div>
				)}
				{extra}
			</div>
		</div>
	);
}

export default DashboardWidgetHeader;
